import React, { useState } from "react";
import styles from "../QuestionBox/QuestionBoxStyles.module.css";
import moment from "moment";
import {
  convertEpochToTimestamp,
  handlePauseAllVideo,
  highlightImpPara,
  removeVIZAPFromText,
  replaceContentEditableText
} from "../../utils";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import AttachmentBox from "../AttachmentBox/AttachmentBox";
import "./AnswerCardStyles.css";
import CarouselImage from "../Carousel/Carousel";
import { useDispatch, useSelector } from "react-redux";
import { bindActionCreators } from "redux";
import { Actions } from "../../Action";
import Voting from '../Rating/voting';
import { InView } from "react-intersection-observer";
import { updateViewCount } from "../../API/api";
import { BASE_URL, CURRENT_ROLE } from "../../API/url";
import { useLocation } from "react-router-dom";
import Rating from "../Rating/Rating";
import styles2 from "./NewCardStyles.module.css";

export default function PdfAnswerCard({ answer, question }) {
  const currentPath = useLocation();
  if(currentPath.pathname.includes('editor') && answer.expert === null){
    answer.expert = {};
    answer.expert.firstName = 'Vizerto';
    answer.expert.lastName = 'Bot';
    answer.expert.userUuidStr = '';
  }
  const dispatch = useDispatch();
  const modalName = useSelector((state) => state.domain.modalName);
  const { advanceFilterModalToggle, getSelectedAnswer, getSelectedQuestion, allScrolledAnswerUuid, answerUuidSentToUpdateViewCount } =
    bindActionCreators(Actions, dispatch);
    const randomNumber = Math.random()*10;
  const searchState = useSelector((state) => state.search);
  const domainState = useSelector((state) => state.domain.ratings);
  const inlineImageState = useSelector((state) => state.domain);
  const trendingState = useSelector((state) => state.trending);
  const isRatingDone = useSelector((state) => state.domain.isRatingLoad);

  const addInlineImagesToAnswer = () =>{
    answer.answerText = answer.answerText.replaceAll(
      '<video ',
      `<video  width="80%" height="300" id=${question.questionUuid}_${randomNumber}`
    );
    answer.answerText = answer.answerText.replaceAll(
      '<img ',
      "<img style='max-width:50%'"
    );
    if(inlineImageState.inlineImagesList && inlineImageState.inlineImagesList.length > 0 ){
      for(let i = 0; i < inlineImageState.inlineImagesList.length;++i){
        if(inlineImageState.inlineImagesList[i].includes('.png')){
          let replacedContent = `[content|${inlineImageState.inlineImagesList[i].split('.')[0]}|]`;
        let imgTag = `<img style='max-width:50%' src=${inlineImageState.inlineImagesData[inlineImageState.inlineImagesList[i]]}></img>`;
        if(answer.answerText.includes(replacedContent)){
          answer.answerText = answer.answerText.replaceAll(replacedContent, imgTag)
        }
        }
      }
    }
  }
  addInlineImagesToAnswer();
  const [isExpand, setIsExpand] = useState(false);
  const [showHideVideo, setShowHideVideo] = useState(false);
  const userState = useSelector((state) => state.user);

  const onChangeExpand = (flag) => {
    setIsExpand(flag);
  };
  const extractProfilePicFromStore = () => {

      return "";
  };

  const onClickRFU = () => {
    advanceFilterModalToggle({ bool: true, value: "requestForUpdate" });
    getSelectedAnswer(answer);
    getSelectedQuestion(question);
  };
  const momentit = (stime) => {
    if (Number(Date.now()) - Number(stime) < 259200000) {
      return moment(new Date(Number(stime))).fromNow();
    } else {
      return moment(convertEpochToTimestamp(stime)).format("ll");
    }
  };

  const helpfulAPIPayload = {
    questionUuid: question.questionUuid,
    answerUuid: answer.answerUuid,
    status: "accepted",
    questionText: searchState.inputValue,
    answerText: answer.answerCopy,
    pdfId: answer?.attachments[0]?.name?.split(".")[0],
  };
  const getAnswerUuidsForViewCountUpdation =(flag, question)=>{
    if(flag){
      if(!trendingState.AllScrolledAnswerUuid.includes(question.docId)){
        let payload ={
          answerIds:[],
          docIds:question.docId.split()
        }
        let ar = trendingState.AllScrolledAnswerUuid;
        ar.push(question.docId)
        allScrolledAnswerUuid(ar);
        updateViewCount(payload, answerUuidSentToUpdateViewCount)
    }
  }}
  const state = useSelector((state) => state?.user);
  const location = useLocation();
 
  // const isId4Present = data.some(item => item.id === 4);
  const check = state?.roles
    ?.filter((item) => item.roleName === "Seeker")
    .map((item) => {
      let val = item?.permissions;
      return val.some(item => item.id === 9);
    });

  const isDisabled =  check[0]===true ? false : true ;



  return (
    <InView as="div" onChange={(inView, entry) => getAnswerUuidsForViewCountUpdation(inView,question)}>
      <div className="col-md-12">
      <div className={styles.answerDiv}>
        <div className={styles.expertInfo}>
          <div className={styles2.newContainer}>
            <div className={styles2.subcontainerLeft}>
              <div style={{display:'flex', justifyContent:'start', flexWrap:'wrap', alignItems:'center'}}>
              <div>
              <img
            className="rounded-circle"
            alt="40x40"
            src={
              extractProfilePicFromStore() ||
              require("../../Images/bot-icon.png")
            }
            id={styles.expertProfilePicture}
            data-holder-rendered="true"
          ></img>
              </div>
              <div style={{marginLeft:'5px', fontSize:'14px', fontWeight:'500'}}><p style={{marginBottom:'0px'}}>{answer.expert.firstName}</p><p style={{marginBottom:'0px'}}>{answer.expert.lastName !== 'Bot' && answer.expert.lastName}</p></div>
              </div>
              <div style={{display:'flex', justifyContent:'start', flexWrap:'wrap', alignItems:'center'}}>
              {answer.answeredTimestamp && (
              <div className={styles.answeredInfo}>
                <span className="datestamp">
                  Answered {momentit(answer.answeredTimestamp)}
                </span>
              </div>
            )}
              </div>
              <div style={{display:'flex', justifyContent:'start'}}>
            {question.usageAccess === "internal" && (
                <div
                className={styles.viewScore}
                >
                  <i className="fa fa-user-times"></i>&nbsp;Internal Only
                </div>
              )}
            </div>
            </div>
            <div className={styles2.subcontainerMiddle} style={{backgroundColor:`${currentPath.pathname.includes('/search')?question.confidence?'green':'orange':'var(--light_color_shade)'}`}}></div>
            <div className={styles2.subcontainerRight}>
          <div className="row">
            {answer.answerText.length >= 550 ? (
              <div
                className={`${styles.answerBlock} ${
                  isExpand ? "" : "hideAnswerText"
                }`}
                dangerouslySetInnerHTML={{ __html: isExpand
                  ? 
                      highlightImpPara(
                        replaceContentEditableText(answer.answerText),
                        question.startSpan,
                        question.endSpan,
                        question.summarisedText
                      )
                    
                  : 
                      question.summarisedText === "" ||
                        question.summarisedText === undefined
                        ? replaceContentEditableText(answer.answerText)
                        : removeVIZAPFromText(question.summarisedText)
                    } }
              >
              </div>
            ) : (
              <div className={`${styles.answerBlock}`} dangerouslySetInnerHTML={{ __html:
                highlightImpPara(
                  replaceContentEditableText(answer.answerText),
                  question.startSpan,
                  question.endSpan,
                  question.summarisedText
                )
               }}>
              </div>
            )}
          </div>
          {answer.answerText.length >= 550 && (
            <div className={`${isExpand ? "" : "fader"}`}></div>
          )}
          {answer.answerText.length >= 550 && (
            <div className={`mb-2 mt-2 showmorediv`}>
              {isExpand ? (
                <span onClick={() => onChangeExpand(false)}>
                  <i
                    className="fa fa-angle-up"
                    style={{ fontWeight: "bold", cursor: "pointer" }}
                  ></i>
                </span>
              ) : (
                <span
                  style={{ fontSize: "14px", cursor: "pointer" }}
                  onClick={() => onChangeExpand(true)}
                >
                  <i
                    className="fa fa-angle-down"
                    style={{ fontWeight: "bold" }}
                  ></i>{" "}
                  show more
                </span>
              )}
            </div>
          )}
          {answer.attachmentURL && answer.attachmentURL.length > 0 && (
            <div className="mb-4">
              <CarouselImage attachments={answer.attachmentURL} />
            </div>
          )}
          {question.url && (
            <div className="mt-2" style={{ fontSize: "13px" }}>
              URL:{" "}
              <a
                href={question.url}
                target="_blank"
                style={{ color: "var(--light_color_shade)", textDecoration:'none' }}
              >
                {question.url}
              </a>
            </div>
          )}
          </div>
          </div>
          {/* dont change from here */}
          <div
            className={`${
              answer.attachments && answer.attachments.length > 0
                ? "mt-1"
                : null
            }`}
            style={{display:'flex', flexWrap:'wrap'}}
          >
            {answer.attachments &&
              answer.attachments.map((attachment) => {
                return (
                  <AttachmentBox
                    key={attachment.name}
                    attachment={attachment}
                  />
                );
              })}
          </div>
          {modalName !== "generativeREsponse" && <div style={{display:'flex', justifyContent:'space-between'}}>
            <div style={{display:'flex',alignItems:"center"}}>
            <OverlayTrigger
                placement="top"
                delay={{ show: 250, hide: 400 }}
                overlay={
                  <Tooltip>Number of times this answer was viewed</Tooltip>
                }
              >
                <span style={{ cursor: "pointer" }}>
                  <span className={styles.viewCount}>
                    {answer.popularityScore && <i className="fa fa-eye"></i>}
                  </span>
                  <span className={styles.viewScore}>
                    {answer.popularityScore}
                  </span>
                </span>
              </OverlayTrigger>
            </div>
            <div >
              <div className="text-end">
                <div className={styles.helpfulButton}>
                  { answer.isVerifyShow === undefined ? (
                    CURRENT_ROLE === 'Seeker' && <span style={{ fontSize: "12px", marginTop: "8px" }}>
                      <button
                        // className={`btn btn-primary videoshowbuttonAB`}
                        onClick={() => onClickRFU()}
                        style={{minWidth:'80px', marginBottom:`${isDisabled? "10px":"0px"}`}}
                        disabled={isDisabled}
                        className={isDisabled ? styles2.disabledButton:`btn btn-primary videoshowbuttonAB`}
                      >
                        Verify
                        
                      </button>
                    </span>
                  ) : (
                    <span style={{ fontSize: "12px", marginTop: "15px" }}>
                      Expert will verify it shortly.{" "}
                      <img
                        src={require("../../Images/chatoutline.png")}
                        style={{
                          width: "18px",
                          height: "20px",
                          marginTop: "-3px",
                        }}
                      />
                    </span>
                  )}
                  &nbsp;&nbsp;
                  {isRatingDone &&!currentPath.pathname.includes('editor') && domainState !== null && domainState[answer.docId] !== undefined && (
                    <div id={styles.btnHelpful}>
                      <Voting
                        helpful={helpfulAPIPayload}
                        answer={answer}
                      />
                    </div>
                  )}
                  { isRatingDone && currentPath.pathname.includes('editor') &&  domainState !== null &&
                    domainState[answer.docId === undefined ?answer.origAnswerUuid:answer.docId] !== undefined && (
                      <div id={styles.btnHelpful}>
                        <Rating
                          helpful={helpfulAPIPayload}
                          id={answer.docId === undefined ?answer.origAnswerUuid:answer.docId}
                          rating={domainState[answer.docId === undefined ?answer.origAnswerUuid:answer.docId]}
                          isDisable={
                            answer.expert.lastName === "Bot"
                              ? true
                              : undefined
                          }
                        />
                      </div>
                    )}
                </div>
              </div>
            </div>
          </div>}
        </div>
      </div>
    </div>
    </InView>
  );
}
